import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import styles from './Forbidden.module.css'
import Icon404 from '../../images/pineapple-404.gif'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../redux/rootReducer'
import { getAdminDetails } from '../../redux/auth/actions/auth.action'

const Forbidden = () => {
    const dispatch: AppDispatch = useDispatch();
    useEffect(() => {
        dispatch(getAdminDetails());
    }, []);

    return (
        <div className={styles.container}>
            <img className={styles.notFoundImage} src={Icon404} alt="404" />
            <p>{`⚠️ Oops! Looks like you’re not authorized to access this page.`}</p>
        </div>
    )
}

export default Forbidden
